
<template>
    <div class="addworkorder">
        <div class="addworkHead">
                    <div class="backWorkOrderList"
                         v-if="this.$route.query.url!=='customerDetail'"
                         @click="backworkOrder"
                    >

                       <span><i class="el-icon-arrow-left" style="font-size: 17px;font-weight: 400"></i></span>
                          <span >返回工单列表</span>
                    </div>
          <div class="backWorkOrderList"
               v-if="this.$route.query.url==='customerDetail'"
               @click="backworkOrder"
          >
            <span><i class="el-icon-arrow-left" style="font-size: 17px;font-weight: 400"></i></span>
            <span >返回客户详情</span>
          </div>

                    <div class="centerTitle">新增工单</div>

        </div>
        <div class="addworkorderContain">
            <el-scrollbar style="height:100%">
                <div style="height:100%" class="templateClass">
                    <div class="selectWorkOrder">
                        <div style="padding-bottom: 8px"><span style="color: red">*</span>工单模板</div>
                        <div>
                            <el-select v-model="template"
                                       placeholder="请选择"
                                       @change="getTemplate"
                                       style="width: 30%;"
                            >
                                <el-option
                                        v-for="item in workOrderTemplate.list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="WorkOrderTheme">
                        <div style="padding-bottom: 8px"> <span style="color: red">*</span>主题</div>
                        <div>
                            <el-input
                                    placeholder="请输入工单主题"
                                    v-model="inputTheme"
                                    clearable
                            >
                            </el-input>
                        </div>
                     </div>
                    <div class="addworkorderDec" style="font-size: 14px">
                         <div style="padding-bottom: 8px"><span style="color: red">*</span>描述</div>
                        <div>
                            <vue-ueditor-wrap v-model="ueditor" :config="myConfig" placeholder="请输入内容"/>
                        </div>
                    </div>
                    <div class="addworkorderOne" style="font-size: 14px">
                        <el-row :gutter="24">
                            <el-col :span="10">
                                <div class="addworkorderCustom">
                                    <div style="padding: 10px 0"><span style="color: red" v-if="customerCheck">*</span>客户</div>
                                    <div>
                                        <el-select v-model="clientValue"
                                                   placeholder="请选择"
                                                   style="width: 55%;position: relative"
                                                   v-loadmore="loadMoreClient"
                                        >
                                            <div style="margin: 5px 0">
                                                <el-input
                                                        placeholder="可搜索"
                                                        v-model="clientSelect"
                                                        clearable
                                                        style="position: absolute;top: 0;z-index: 9;line-height: 40px;"
                                                        @input="changeInput"
                                                >
                                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                                </el-input>
                                            </div>
                                            <div v-if="selectClient.length===0">
                                                <el-option
                                                        label=""
                                                        value=""
                                                        style="height: 5px"
                                                >
                                                </el-option>
                                            </div>
                                            <div style="margin-top: 40px;">
                                                <el-option
                                                        v-for="item in selectClient"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </div>
                                        </el-select>

                                            <span class="addcustom" @click="addClientBtn">新增客户</span>


                                    </div>

                                </div>
                                 </el-col>
                            <el-col :span="7">
                                <div class="addworkordergroup">
                                    <div style="padding: 10px 0"><span style="color: red" v-if="groupCheck">*</span>受理组</div>
                                    <el-select
                                            v-model="groupValue"
                                            placeholder="请选择"
                                            style="width: 100%;position: relative"
                                            @change="getAccountPerson"
                                    >
                                        <div style="margin: 5px 0">
                                            <el-input
                                                    placeholder="可搜索"
                                                    v-model="groupSelect"
                                                    clearable
                                                    style="position: absolute;top: 0;z-index: 9;line-height: 40px;margin-bottom: 4px"
                                                    @input="changeInputGroup"
                                            >
                                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                            </el-input>
                                        </div>
                                        <div v-if="selectGroup.length===0">
                                            <el-option label="" value="" style="height: 5px">无数据</el-option>
                                        </div>
                                        <div style="margin-top: 40px;">
                                            <el-option
                                                    v-for="item in selectGroup"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id"

                                            >
                                            </el-option>
                                        </div>

                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :span="7">
                                <div class="addworkorderperson">
                                    <div style="padding: 10px 0"><span style="color: red" v-if="personCheck">*</span>受理人</div>
                                    <el-select v-model="personValue"
                                               filterable
                                               placeholder="请选择"
                                               style="width: 100%;position: relative"
                                    >
                                        <div style="margin: 5px 0">
                                            <el-input
                                                    placeholder="可搜索"
                                                    v-model="assignSelect"
                                                    clearable
                                                    style="position: absolute;top: 0;z-index: 9"
                                                    @input="changeInputPerson"
                                            >
                                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                            </el-input>
                                        </div>
                                        <div v-if="selectAccountPerson.length===0">
                                            <el-option value="" style="height: 5px"></el-option>
                                        </div>
                                        <div style="margin-top: 40px">
                                            <el-option
                                                    v-for="item in selectAccountPerson"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </div>

                                    </el-select>
                                </div>
                            </el-col>

                        </el-row>

                    </div>
                    <div class="addworkorderTwo" style="font-size: 14px">
                        <el-row :gutter="20">
                            <el-col :span="10">
                                <div class="addworkorderFollow">
                                    <div style="padding: 10px 0"><span style="color: red" v-if="focusCheck">*</span>关注人</div>
                                    <el-select v-model="focusPerson"
                                               style="width: 55%;position:relative;"
                                               multiple
                                               placeholder="请选择">
                                        <div style="margin: 5px 0">
                                            <el-input
                                                    placeholder="可搜索"
                                                    v-model="focusPersonSelect"
                                                    clearable
                                                    style="position: absolute;top: 0;z-index: 9"
                                                    @input="changeFocusPerson"
                                            >
                                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                            </el-input>
                                        </div>
                                        <div v-if="selectFocusPerson.length===0">
                                            <el-option value="" style="height: 1px">
                                            </el-option>
                                        </div>
                                        <div style="margin-top: 40px">
                                            <el-option
                                                    v-for="item in selectFocusPerson"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id"
                                            >
                                            </el-option>
                                        </div>

                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :span="7">
                                <div class="addpriority">
                                    <div style="padding: 10px 0"><span style="color: red">*</span>优先级</div>
                                    <el-select v-model="priorityValue"
                                               placeholder="请选择"
                                               style="width: 100%"
                                    >
                                        <el-option
                                                v-for="item in prioritySelect"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :span="7">
                                <div class="addstatus">
                                    <div style="padding: 10px 0"><span style="color: red">*</span>状态</div>
                                    <el-select v-model="statusList"
                                               placeholder="请选择"
                                               style="width: 100%"
                                    >
                                        <el-option
                                                v-for="item in status.list"
                                                :value="item.id"
                                                :label="item.name"
                                                :key="item.id"
                                        ></el-option>
                                     <!--   <el-option value="受理中" label="受理中" style="background-color: #E1E600;color: white"></el-option>
                                        <el-option value="已解决" label="已解决" style="background-color: #03B615;color: white"></el-option>
                                        <el-option value="已关闭" label="已关闭" style="background-color: #D7D7D7;color: white"></el-option>-->
                                    </el-select>
                                </div>
                            </el-col>

                        </el-row>

                    </div>

                    <div style="width: 65%;margin:0 auto 10px auto" >
                        <div style="display: flex; flex-wrap: wrap;">
                            <div
                                    v-for='(item,index) in addWorkOrderTemplateList'
                                    :key="item.fieldId"
                                    :class="getClassTest(item.field.type,index)"
                            >
                                    <div v-if="item.field.type==='SELECT'" >
                                        <div class="defaultFiledSelect">
                                          <div class="defaultSelectText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>

                                            <el-select v-model="selectValue[index]"
                                                       placeholder="请选择"
                                                       style="width: 100%"
                                            >
                                                <el-option
                                                        v-for="items in item.field.extInfo.exinfo"
                                                        :key="items.value"
                                                        :label="items.value"
                                                        :value="items.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>


                                    <div v-if="item.field.type==='CASCADER'"  >
                                        <div
                                                class="addOrderDefaultFiledCascade2"
                                        >
                                            <div class="defaultCascadeText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                            <div>
                                                <el-cascader
                                                        clearable
                                                        v-model="cascade2Option1[index]"
                                                        :options="item.field.extInfo.cascadeDown[0].options"
                                                        style="width: 100%"
                                                ></el-cascader>
                                            </div>

                                        </div>
                                    </div>




                                    <div v-if="item.field.type==='DATE_PICKER'">
                                        <div
                                                class="defaultFieldDatePicker"
                                        >
                                            <div class="defaultDatePickerText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                            <el-date-picker
                                                    v-model="datePicker[index]"
                                                    type="date"
                                                    placeholder="选择日期"
                                                    style="width: 100%"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </div>




                                    <div v-if="item.field.type==='TIME_PICKER'">
                                        <div
                                                class="defaultFieldTimePicker"
                                        >
                                            <div class="defaultTimePickerText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                            <el-time-picker
                                                    v-model="timePicker[index]"
                                                    placeholder="任意时间点"
                                                    style="width: 100%"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                   <div v-if="item.field.type==='INPUT'" style="clear: both">
                                   <div class="defaultFiledSingeText">
                                       <div class="defaultSingeTextText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                       <el-input
                                               placeholder="请输入内容"
                                               v-model="singeInput[index]"
                                               clearable
                                               class="singeTextInput"
                                       >
                                       </el-input>
                                   </div>
                               </div>

                               <div v-if="item.field.type==='TEXTAREA'" style="clear: both">
                                   <div class="defaultFiledTextarea" >
                                       <div class="defaultTextareaText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                       <el-input
                                               type="textarea"
                                               :rows="2"
                                               placeholder="请输入内容"
                                               v-model="textarea[index]"
                                               class="TextareaInput"

                                       >
                                       </el-input>
                                   </div>
                               </div>

                               <div v-if="item.field.type==='RADIO'" style="clear: both">
                                   <div class="defaultFiledRadio" >
                                       <div class="defaultRadioText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                       <div style="padding: 5px 0 5px 0">
                                           <el-radio-group v-model="defaultFieldRadio[index]" style="line-height: 32px">
                                               <el-radio
                                                       v-for="items in item.field.extInfo.exinfo"
                                                       :label="items.value"
                                                       :key="items.value"
                                                       :value="items.value"
                                                       style="min-width:72px;"
                                               ></el-radio>
                                           </el-radio-group>
                                       </div>

                                   </div>
                               </div>
                               <div v-if="item.field.type==='CHECKBOX'" style="clear: both">
                                   <div class="defaultFiledCheckBox">
                                       <div class="defaultCheckBoxText"><span style="color: red" v-if="item.required">*</span>{{item.field.name}}</div>
                                       <div style="padding: 5px 0 10px 0">
                                           <el-checkbox-group v-model="checkList[[index]]">
                                               <el-checkbox
                                                       v-for="items in item.field.extInfo.exinfo"
                                                       :key="items.value"
                                                       :label="items.value"
                                                       :value="items.value"
                                                       style="min-width:72px;"
                                               ></el-checkbox>
                                           </el-checkbox-group>
                                       </div>

                                   </div>
                               </div>

                            </div>
                        </div>

                    </div>

                </div>
            </el-scrollbar>
        </div>
        <div class="addworkorderFooter">
            <span>
                <el-button size="medium"  @click="cacelClick">取消</el-button>
                <el-button size="medium" type="primary" @click="addWorkOrder"><span style="color: white">新增工单</span></el-button>

            </span>
        </div>
        <el-dialog title="新增客户"  :visible.sync="dialogFormVisible" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
            <div class="flexClass" style="margin-bottom: 10px">
                <div  class="flexClass1"><span style="color: red">*</span>客户名称</div>
                <div class="flexClass2">
                    <el-input
                            placeholder="请输入客户名称"
                            v-model="clientName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">
                    等级
                </div>
                <div class="flexClass2">
                    <el-radio v-model="levelRadio" label="1" style="margin-right: 8px">普通</el-radio>
                    <el-radio v-model="levelRadio" label="2">vip</el-radio>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">电话</div>
                <div class="flexClass2" >
                    <el-input
                            placeholder="请输入电话"
                            v-model="clientTel"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">邮箱</div>
                <div class="flexClass2" >
                    <el-input
                            placeholder="请输入邮箱"
                            v-model="clientMail"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass" >
                <div class="flexClass1">公司</div>
                <div class="flexClass2" >
                    <el-select v-model="companyValue"
                               clearable
                               filterable
                               placeholder="请选择或者搜索公司名称"
                               style="width: 100%;position: relative"
                               v-loadmore="loadMoreCompany"
                    >
                        <div style="margin: 5px 0" >
                            <el-input
                                    placeholder="可搜索"
                                    v-model="companySelect"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 9"
                                    @input="changeSelectCompany"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectCompanyList.length===0" >
                            <el-option style="height: 32px" ></el-option>
                        </div>
                        <div style="margin-bottom: 32px;margin-top: 40px">
                            <el-option
                                    v-for="item in selectCompanyList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                        <div
                                style="background-color: #409EFF;text-align: center;height: 32px;line-height: 32px;cursor: pointer;width: 100%;position: absolute;bottom: 0"
                                @click="dialogFormVisible1=true"
                                :class="{isNullOption:selectCompanyList.length===0}"
                        >
                                                    <span style="color: white">
                                                          新建公司
                                                    </span>

                        </div>
                    </el-select>
                </div>
            </div>
            <div class="flexClass" >
                <div class="flexClass1">负责组</div>
                <div class="flexClass2" >
                    <el-select v-model="groupValue"
                               clearable
                               placeholder="请选择或者搜索负责组"
                               style="width: 100%;position: relative"
                               @change="getAccountPerson"
                    >
                        <div style="margin: 5px 0">
                            <el-input
                                    placeholder="可搜索"
                                    v-model="flitable"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 9"
                                    @input="changeInputGroup"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectGroup.length===0">
                            <el-option label="" value="" style="height: 5px"></el-option>
                        </div>
                        <div style="margin-top: 40px">
                            <el-option
                                    v-for="item in selectGroup"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"

                            >
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="flexClass">
                <div  class="flexClass1">负责人</div>
                <div class="flexClass2" >
                    <el-select v-model="personValue"
                               clearable
                               placeholder="请选择或者搜索负责人"
                               style="width: 100%;position: relative"
                    >
                        <div style="margin: 5px 0">
                            <el-input
                                    placeholder="可搜索"
                                    v-model="personSelect"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 9"
                                    @input="changeInputPerson"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectAccountPerson.length===0">
                            <el-option value="" style="height: 5px"></el-option>
                        </div>
                        <div style="margin-top: 40px;margin-bottom: 5px">
                            <el-option
                                    v-for="item in selectAccountPerson"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="flexClass">
                <div  class="flexClass1">描述</div>
                <div class="flexClass2">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="对该客户的描述"
                            v-model="describe">
                    </el-input>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addClient">保存</el-button>
                <el-button type="primary" @click="addClientContinue">保存并继续添加</el-button>
            </div>
        </el-dialog>

        <el-dialog title="新增公司" :visible.sync="dialogFormVisible1" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1"><span style="color: red">*</span>公司名称</div>
                <div class="companyFlexClass2">
                    <el-input
                            placeholder="请输入公司名称"
                            v-model="addCompanyName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">
                    等级
                </div>
                <div class="companyFlexClass2">
                    <el-radio v-model="companyLevelRadio" label="1" style="margin-right: 8px">普通</el-radio>
                    <el-radio v-model="companyLevelRadio" label="2">vip</el-radio>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px;">
                <div class="companyFlexClass1">公司邮箱后缀
                    <el-popover
                            placement="top-start"
                            width="230"
                            trigger="hover"
                    >
                        <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

                        <span slot="reference" style="margin-left: 4px;height: 20px;text-align: center">
                                      <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
                    </el-popover>
                </div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司邮箱后缀"
                            v-model="emailSuffix"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">公司联系人</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人姓名"
                            v-model="contactPerson"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">联系人电话</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人电话"
                            v-model="contactPersonTel"
                            clearable
                            @blur="phoneBlurClick"
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">联系人邮箱</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入联系人邮箱"
                            v-model="contactPersonMail"
                            clearable
                            @blur="emaiBblurClick"
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">负责组</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyGroupValue"
                               clearable
                               filterable
                               placeholder="请选择或者搜索负责组"
                               style="width: 100%;position: relative;"
                               @change="getCompanyAccountPerson"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    v-model="groupSelect"
                                    clearable
                                    style="position: absolute;z-index: 999;top: 0"
                                    @input="getSelectCompanyGroup"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="companySelectGroup.length===0">
                            <el-option value="" style="height: 40px"></el-option>
                        </div>
                        <div style="margin-top: 40px" v-if="companySelectGroup.length > 0">
                            <el-option
                                    v-for="item in companySelectGroup"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            >
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="companyFlexClass" style="line-height: 40px">
                <div class="companyFlexClass1">负责人</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyPersonValue"
                               clearable
                               filterable
                               placeholder="请选择或者搜索负责人"
                               style="width: 100%;position: relative"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    v-model="personSelect"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 999"
                                    @input="getSelectCompanyPerson"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="companySelectPerson.length === 0">
                            <el-option value="" style="height: 40px"></el-option>
                        </div>
                        <div style="margin-top: 40px" v-if="companySelectPerson.length > 0">
                            <el-option
                                    v-for="item in companySelectPerson"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div style="display: flex;padding: 6px 0 0 0">
                <div style="flex: 0.2 0.2 0;height: 40px;line-height: 40px;">描述</div>
                <div style="flex: 0.8 0.8 0">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="对该公司的描述"
                            v-model="description">
                    </el-input>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="addClientCompany">保存</el-button>
                <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
let numTest=0
let  numTest1=0
    import VueUeditorWrap from 'vue-ueditor-wrap'
    export default {
        name: "AddWorkOrder",
        components:{VueUeditorWrap},
        data() {
            return {
                dialogFormVisible:false,
                dialogFormVisible1:false,
                flitable:'',
                inputTheme: '',
                ueditor:'',
                content:null,
                focusPerson:[],
                focusPersonSelect:'',
                clientSelect:'',
                groupSelect:'',
                assignSelect:'',
                clientValue:'',
                responsibleGroup:'',
                companySelect:'',
                responsiblePerson:'',
                personSelect:'',
                priorityValue:'',
                prioritySelect:[
                    {
                        value:'URGENT',
                        label:'紧急'
                    },
                    {
                        value:'HIGH',
                        label:'高'
                    },
                    {
                        value:'MIDDLE',
                        label:'中'
                    },
                    {
                        value:'LOW',
                        label:'低'
                    }
                ],
                addstatusSelect:'',
                statusList:'',
                template: '',
                fileList: [],
                clientName:'',
                levelRadio:'1',

                clientTel: '',
                clientMail:'',
                companyValue:'',
                inputSelect: '',
                groupValue:'',
                accountGroup:{
                    list:[]
                },
                personValue:'',
                accountPerson:{
                    list:[]
                },
                describe:'',
                clientGrade:'',
                newStatus:{
                    list:[]
                },
                priorityStatus:'',
                myConfig: {
                    autoHeightEnabled: false, // 编辑器不自动被内容撑高
                    initialFrameHeight: 200, // 初始容器高度
                    initialFrameWidth: '100%', // 初始容器宽度
                    UEDITOR_HOME_URL: ' /ueditor/',
                    serverUrl: "/ueditor-api/",
                    enableAutoSave: false,
                    autoFloatEnabled:false,
                    fullscreen:false,
                    imageScaleEnabled:false,
                    toolbars: [
                        [
                            'undo', //撤销
                            'bold', //加粗
                            'indent', //首行缩进
                            'italic', //斜体
                            'underline', //下划线
                            'strikethrough', //删除线
                            'subscript', //下标
                            'superscript', //上标
                            'formatmatch', //格式刷
                            'fontfamily', //字体
                            'fontsize', //字号
                            'justifyleft', //居左对齐
                            'justifycenter', //居中对齐
                            'justifyright', //居右对齐
                            'justifyjustify', //两端对齐
                            'insertorderedlist', //有序列表
                            'insertunorderedlist', //无序列表
                            'forecolor', //字体颜色
                            'backcolor', //背景色
                            'lineheight',//行间距
                            'link', //超链接
                            'simpleupload', //单图上传
                            'insertvideo', //视频
                            'attachment' ,//附件上传
                            'fullscreen',

                        ]
                    ],
                    'fontfamily':[
                        { label:'',name:'songti',val:'宋体,SimSun'},
                        { label:'仿宋',name:'fangsong',val:'仿宋,FangSong'},
                        { label:'仿宋_GB2312',name:'fangsong',val:'仿宋_GB2312,FangSong'},
                        { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
                        { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
                        { label:'',name:'heiti',val:'黑体, SimHei'},
                        { label:'',name:'lishu',val:'隶书, SimLi'},
                        { label:'',name:'andaleMono',val:'andale mono'},
                        { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
                        { label:'',name:'arialBlack',val:'arial black,avant garde'},
                        { label:'',name:'comicSansMs',val:'comic sans ms'},
                        { label:'',name:'impact',val:'impact,chicago'},
                        { label:'',name:'timesNewRoman',val:'times new roman'}
                    ],
                },
                workOrderTemplate:{
                    list:[]
                },
                accountPersons:{
                    list:[]
                },
                status:{
                    list:[]
                },
                company:{
                    list:[]
                },
                client:{
                    list:[]
                },
                singeInput:[],
                textarea:[],
                isShow:0,
                checkList:[],
                datePicker:[],
                timePicker:[],
                defaultFieldRadio:[],
                selectTemplate:{},
                defaultFiled:[],
                selectValue:[],
                addWorkOrderDateList:[],
                addWorkOrderTimeList:[],
                addWorkOrderSingeList:[],
                addWorkOrderTextareaList:[],
                addWorkOrderSelectList:[],
                addWorkOrderCascadeList:[],
                addWorkOrderRadioList:[],
                addWorkOrderCheckBoxList:[],
                addWorkOrderTemplateList:[],
                addOrderFieldCascadeList1:[],
                addOrderFieldCascadeList2:[],
                optionSelect2List:[],
                optionSelect3List:[],
                cascadeOption1:[],
                cascadeOption2:[],
                cascadeOption3:[],
                cascade2Option1:[],
                cascadeList:[],
                mode:{},
                fieldList:[],
                showTitle:'',
                pageSize:100,
                currentPage:1,
                companyPageSize:100,
                addCompanyName:'',
                emailSuffix:'',
                companyLevelRadio:'1',
                contactPerson:'',
                contactPersonTel:'',
                contactPersonMail:'',
                companyGroupValue:'',
                companyPersonValue:'',
                description:'',
                companyAccountPerson:{
                    list:[]
                },
                groupArr:[],
                selectClient:[],
                selectGroup:[],
                selectAccountPerson:[],
                selectCompanyAccountPerson:[],
                selectCompanyAccountGroup:[],
                selectFocusPerson:[],
                selectCompanyList:[],
                secondeOption:[],
                thirdeOption:[],
                addClientSuccess:false,
                addCompanySuccess:false,
                selectCascaseDateTime:[],
                fff:{},
                aaa:{},
                cascadettt:false,
                firstClass:'',
                secondClass:0,

                seconde:0,
                first:0,
                thirde:0,
                companySelectGroup:[],
                companySelectPerson:[],
                customerCheck:false,
                groupCheck:false,
                personCheck:false,
                focusCheck:false,
              filed:{
                  list:[]
              }

            }

        },
        mounted() {
            this.getWorkOrderTemplate()
            this.getClientCompany()
            this.getClientList()
            this.getAccountGroup()
            this.getStatusList()
            this.getAccountPersons()
            this.getAccountPerson()
            this.getCompanyAccountPerson()
            this.priorityValue='MIDDLE'
        },

        methods:{
            getClassTest(type,index){
                    if(type==='CASCADER'||type==='SELECT'||type==='DATE_PICKER'||type==='TIME_PICKER')
                    {
                        if(index!==0)
                        {

                            if(this.addWorkOrderTemplateList[index-1].field.type==='INPUT'||this.addWorkOrderTemplateList[index-1].field.type==='TEXTAREA'||this.addWorkOrderTemplateList[index-1].field.type==='RADIO'||this.addWorkOrderTemplateList[index-1].field.type==='CHECKBOX')
                            {
                                numTest=index
                                return 'newClassStyle1'
                            }
                            else
                            {

                                numTest1=index-numTest
                                if(numTest1%3===0)
                                {
                                    this.first=1
                                    return 'newClassStyle1'
                                }

                                if(numTest1%3===1)
                                {
                                    this.seconde=1
                                    return 'newClassStyle2'
                                }

                                if(numTest1%3===2)
                                {
                                    this.thirde=1
                                    return 'newClassStyle3'
                                }
                               /* if(numTest1%3 < 0)
                                {
                                  console.log('aaa')
                                  return 'newClassStyle2'
                                }*/
                            }
                        }
                        if(index===0)
                        {
                            if(this.addWorkOrderTemplateList[index-1]!==undefined)
                            {
                                if(this.addWorkOrderTemplateList[index-1].field.type==='INPUT'||this.addWorkOrderTemplateList[index-1].field.type==='TEXTAREA'||this.addWorkOrderTemplateList[index-1].field.type==='RADIO'||this.addWorkOrderTemplateList[index-1].field.type==='CHECKBOX')
                                {
                                    numTest=index
                                    return 'newClassStyle1'
                                }
                                else
                                {


                                    numTest1=index-numTest
                                    if(numTest1%3===0)
                                    {
                                        return 'newClassStyle1'

                                    }

                                    if(numTest1%3===1)
                                    {
                                        return 'newClassStyle2'
                                    }

                                    if(numTest1%3===2)
                                    {
                                        return 'newClassStyle3'
                                    }

                                }
                            }
                            else
                            {
                                numTest1=index-numTest
                                if(numTest1%3===0)
                                {
                                    return 'newClassStyle1'
                                }

                                if(numTest1%3===1)
                                {
                                    return 'newClassStyle2'
                                }

                                if(numTest1%3===2)
                                {
                                    return 'newClassStyle3'
                                }
                              /*if(numTest1%3 < 0)
                              {
                                return 'newClassStyle1'
                              }*/

                            }

                        }
                    }
                    else
                        return 'otherClassStyle'
            },


            //新增工单
            addWorkOrder(){
                if(this.inputTheme==''){
                    this.$message.error('请输入工单主题');
                    return;
                }
                if(this.ueditor==''){
                    this.$message.error('工单描述不能为空');
                    return;
                }
                if(this.customerCheck){
                    if(this.clientValue==''){
                        this.$message.error('客户不能为空');
                        return;
                    }
                }
                if(this.groupCheck){
                    if(this.groupValue==''){
                        this.$message.error('受理组不能为空');
                        return;
                    }
                }
                if(this.personCheck){
                    if(this.personValue==''){
                        this.$message.error('受理人不能为空');
                        return;
                    }
                }
                if(this.focusCheck){
                    if(this.focusPerson.length ===0){
                        this.$message.error('关注人不能为空');
                        return;
                    }
                }
                this.cascadeSelectThire()
                let fieldValue={}

                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){

                            if(this.addWorkOrderTemplateList[i].field.type==='DATE_PICKER')
                                fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.datePicker[i]

                    }
                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){

                            if(this.addWorkOrderTemplateList[i].field.type==='TIME_PICKER')
                                 fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.timePicker[i]

                    }


                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){
                        if(this.addWorkOrderTemplateList[i].field.type==='INPUT')
                          fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.singeInput[i]
                    }


                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){
                        if(this.addWorkOrderTemplateList[i].field.type==='TEXTAREA')
                             fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.textarea[i]
                    }

                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){
                        if(this.addWorkOrderTemplateList[i].field.type==='SELECT')
                            fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.selectValue[i]
                    }

                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++){
                        if(this.addWorkOrderTemplateList[i].field.type==='CASCADER')
                            fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.cascade2Option1[i]
                    }

                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++)
                    {
                            if(this.addWorkOrderTemplateList[i].field.type==='RADIO')
                                fieldValue[this.addWorkOrderTemplateList[i].fieldId]=this.defaultFieldRadio[i]
                    }

                    for(let i=0;i<this.addWorkOrderTemplateList.length;i++) {
                      if (this.addWorkOrderTemplateList[i].field.type === 'CHECKBOX')
                        fieldValue[this.addWorkOrderTemplateList[i].fieldId] = this.checkList[i]

                    }
                    console.log(fieldValue)
                    for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                    {
                        if(this.addWorkOrderTemplateList[i].required===true) {

                          if (fieldValue[this.addWorkOrderTemplateList[i].fieldId] === undefined || fieldValue[this.addWorkOrderTemplateList[i].fieldId] === '' || fieldValue[this.addWorkOrderTemplateList[i].fieldId].length === 0) {
                            this.$message.error(this.addWorkOrderTemplateList[i].field.name + '是必填的')
                            return
                          }
                        }
                    }

                this.ueditor=this.ueditor.replace(/img/g, "img onclick='previewImage(this)'");
                    console.log(this.ueditor)
                this.$http.post('/api/order',{
                        assigneeGroupId: this.groupValue,
                        assigneeId: this.personValue,
                        clientId: this.clientValue,
                        description: this.ueditor,
                        fieldValue:fieldValue,
                        followersId:this.focusPerson,
                        name: this.inputTheme,
                        priority: this.priorityValue,
                        statusId: this.statusList,
                        templateId: this.template,
                        source:'ADD_MANULLY'
                    }).then(res=>{
                        if(res.data.code==='0')
                        {
                            this.$message.success('新增工单成功')
                            setTimeout( ()=> {
                                this.$router.push('/workorderinfo')
                            },500)
                        }
                    })
                   this.groupValue=''
                    this.personValue=''
                   this.clientValue=''
                   this.ueditor=''

                   this.focusPerson=[]
                    this.inputTheme=''
                   this.priorityValue=''
                  this.statusList=''
                     this.template=''
                this.addWorkOrderDateList=[]
                this.addWorkOrderTimeList=[]
                this.addWorkOrderCheckBoxList=[]
                this.addWorkOrderRadioList=[]
                this.addOrderFieldCascadeList2=[]
                this.addWorkOrderSelectList=[]
                this.addWorkOrderTextareaList=[]
                this.addWorkOrderSingeList=[]
                this.addOrderFieldCascadeList1=[]
            },
            addClientBtn(){
                this.clientName=''
                this.levelRadio='1'
                this.clientTel=''
                this.clientMail=''
                this.groupValue=''
                this.personValue=''
                this.companyValue=''
                this.describe=''
                this.dialogFormVisible=true
            },
            //新增客户
            addClient(){
                if(this.levelRadio==='1'){
                    this.clientGrade='NORMAL'
                }
                if(this.levelRadio==='2'){
                    this.clientGrade='VIP'
                }
                if(this.clientName!=='')
                {
                    this.$http.post('/api/client', {

                        name:this.clientName,
                        grade:this.clientGrade,
                        tel:this.clientTel,
                        mail:this.clientMail,
                        groupId: this.groupValue,
                        principalId: this.personValue,
                        companyId: this.companyValue,
                        company:this.companyName,
                        clientSource: "ADD_MANULLY",
                        description: this.describe
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加客户成功')
                            this.addClientSuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientList()
                        /*   console.debug('post field response:', res);*/

                    });
                    this.dialogFormVisible = false
                }
                else
                    this.$message.error('请输入客户名称')

            },

            addClientContinue(){
                if(this.levelRadio==='1'){
                    this.clientGrade='NORMAL'
                }
                if(this.levelRadio==='2'){
                    this.clientGrade='VIP'
                }
                if(this.clientName!=='')
                {
                    this.$http.post('/api/client', {
                        name:this.clientName,
                        grade:this.clientGrade,
                        tel:this.clientTel,
                        mail:this.clientMail,
                        groupId: this.groupValue,
                        principalId: this.personValue,
                        companyId: this.companyValue,
                        company:this.companyName,
                        clientSource: "ADD_MANULLY",
                        description: this.describe
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加客户成功')
                            this.addClientSuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientList()
                        /*   console.debug('post field response:', res);*/

                    });
                    this.clientName=''
                    this.levelRadio='1'
                    this.clientTel=''
                    this.clientMail=''
                    this.groupValue=''
                    this.personValue=''
                    this.companyValue=''
                    this.describe=''
                    this.dialogFormVisible = true
                }
                else
                    this.$message.error('请输入客户名称')

            },
            //获取客户信息
            getClientList(){
                this.$http.get('/api/client/page?num='+this.pageSize+'&page='+this.currentPage).then(response => {
                    this.client.list = response.data.data.content;
                    this.client.total=response.data.data.totalElements
                    this.selectClient=response.data.data.content;
                    console.log( this.client.list)
                    if(this.addClientSuccess===true)
                    {
                        let length=this.client.list.length
                        this.clientValue=this.client.list[length - 1].id
                    }


                    console.debug('FieldApiExample field page:', this.client);
                })
            },

            //获取公司信息
            getClientCompany(){

                this.$http.get('/api/client-company/page?num='+this.companyPageSize+'&page='+this.currentPage).then(response => {
                    this.company.list = response.data.data.content;
                    this.selectCompanyList=response.data.data.content
                    console.debug('FieldApiExample field page:', this.clientCompany);
                    if(this.addCompanySuccess===true)
                    {

                        let length=this.company.list.length
                        this.companyValue=this.company.list[length - 1].id
                    }
                })

            },

            //获取负责组下拉列表值
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.selectGroup=res.data.data
                    this.companySelectGroup=res.data.data
                })
            },
            //获取负责人的下拉列表值
            getAccountPerson(){
              this.personValue=''
                if(this.groupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectAccountPerson=res.data.data
                        console.log(this.accountPerson.list)

                    })
                }
                if(this.groupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.groupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectAccountPerson=res.data.data

                    })
                }
            },

            //删除数组中存在的重复字段
            /*unique() {
                const res = new Map();
                return this.status.list.filter((item) => !res.has(item.id) && res.set(item.id, 1));
            },*/

            //获取状态
            getStatusList(){
                this.$http.get('/api/status/list')
                    .then(response => {
                        this.status.list = response.data.data;
                        this.statusList=this.status.list[0].id
                        console.log(this.status.list)
                        /* this.statusList.push(this.newStatus.list[0].name)
                         this.statusList.push(this.newStatus.list[1].name)*/
                        console.debug('FieldApiExample field page:', this.status);
                    })
            },
            //获取受理人
            getAccountPersons(){
                this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                    this.accountPersons.list=res.data.data
                    this.selectFocusPerson=res.data.data
                    console.log(this.accountPersons.list)
                })
            },
            //获取工单模板
            getWorkOrderTemplate(){
                this.addWorkOrderDateList=[]
                this.addWorkOrderTimeList=[]
                this.addWorkOrderSingeList=[]
                this.addWorkOrderTextareaList=[]
                this.addWorkOrderSelectList=[]
                this.addOrderFieldCascadeList2=[]
                this.addWorkOrderRadioList=[]
                this.addWorkOrderCheckBoxList=[]
                this.$http.get('/api/template/list').then(res=>{
                    this.workOrderTemplate.list=res.data.data
                    this.template=this.workOrderTemplate.list[0].id
                    this.getDefaultOrderTemplate(this.template)
                })
            },

            //获取初始化模板的工单模板
            getDefaultOrderTemplate(id){
                this.addWorkOrderTemplateList=[]
                this.$http.get('/api/template/'+id).then(res=>{
                    this.selectTemplate=res.data.data
                    console.log(this.selectTemplate)
                    if(Object.keys(this.selectTemplate).length !== 0)
                    {
                        this.setDefaultFieldChecked()
                        console.log(this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0])
                        /*this.addWorkOrderTemplateList=this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0]*/
                      this.$http.get('/api/field/list').then(res => {
                        this.filed.list = res.data.data
                        console.log( this.filed.list)
                        let add=this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0].filter(item=>this.filed.list.some(ele=>ele.id === item.fieldId))
                        this.addWorkOrderTemplateList=add
                        for( let i=0;i<this.addWorkOrderTemplateList.length;i++)
                          this.defaultFieldRadio.push([])
                        for( let i=0;i<this.addWorkOrderTemplateList.length;i++)
                          this.checkList.push([])
                        for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                        {
                          if(this.addWorkOrderTemplateList[i].field.type==='SELECT')
                          {
                            this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                              if(item._default==='true')
                                this.selectValue[i]=item.value
                            })
                          }

                        }
                        for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                        {
                          if(this.addWorkOrderTemplateList[i].field.type==='RADIO')
                          {
                            this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                              if(item._default==='true')
                                this.defaultFieldRadio[i]=item.value
                            })
                          }

                        }
                        for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                        {
                          if(this.addWorkOrderTemplateList[i].field.type==='CHECKBOX')
                          {
                            this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                              if(item._default==='true')
                                this.checkList[[i]].push(item.value)

                            })
                          }
                        }
                        for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                        {

                          if(this.addWorkOrderTemplateList[i].field.type ==='INPUT')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null)
                            {
                              console.log(this.addWorkOrderTemplateList[i].defaultValue)
                              this.singeInput[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }

                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='TEXTAREA')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.textarea[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }

                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='RADIO')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.defaultFieldRadio[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }
                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='SELECT')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.selectValue[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }
                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='CHECKBOX')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.checkList[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }

                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='TIME_PICKER')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.timePicker[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }

                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='DATE_PICKER')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.datePicker[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }

                          }
                          if(this.addWorkOrderTemplateList[i].field.type ==='CASCADER')
                          {
                            if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                              this.cascade2Option1[i]=this.addWorkOrderTemplateList[i].defaultValue
                            }
                          }
                        }
                      })
                      console.log(this.addWorkOrderTemplateList)

                    }

                })
            },

            setDefaultFieldChecked(){
                let defaultFieldList=this.selectTemplate.defaultFieldList;
                if(defaultFieldList!=null){
                    let defaultFieldInfos=defaultFieldList.defaultFieldInfos;
                    if(defaultFieldInfos!=null&&defaultFieldInfos.length>0){
                        for(let i=0;i<defaultFieldInfos.length;i++){
                            let info=defaultFieldInfos[i];
                            if(info.key==='clientId'){
                                this.customerCheck=info.required;
                                console.log(info.defaultValue)
                                if(info.defaultValue!==null)
                                {
                                  this.clientValue=info.defaultValue
                                }

                            }else if(info.key==='assigneeGroupId'){
                                this.groupCheck=info.required;
                              if(info.defaultValue!==null)
                              {
                                this.groupValue=info.defaultValue
                                this.getAccountPerson(this.groupValue)
                              }

                            }else if(info.key==='assigneeId'){
                                this.personCheck=info.required;
                              if(info.defaultValue!==null)
                              {
                                this.personValue=info.defaultValue
                              }

                            }else if(info.key==='followersId'){
                                this.focusCheck=info.required;
                              if(info.defaultValue!==null)
                              {
                                this.focusPerson=info.defaultValue
                                console.log(this.selectFocusPerson)
                              }
                            }else if(info.key ==='priority')
                            {
                              if(info.defaultValue!==null)
                              {
                                if(info.defaultValue.priority!==undefined)
                                {
                                  if(info.defaultValue.priority!=='')
                                  {

                                    this.priorityValue=info.defaultValue
                                  }

                                }

                              }

                            }else if(info.key ==='status'&&Object.keys(info.defaultValue).length > 0)
                            {
                              if(info.defaultValue!==null)
                              {
                                console.log(info.defaultValue)
                                if(info.defaultValue.status!==undefined){
                                  if(info.defaultValue.status!=='')
                                  {
                                    this.statusList=info.defaultValue
                                  }
                                }

                              }

                            }else if(info.key ==='themeName')
                            {
                              if(info.defaultValue!==null)
                              {
                                this.inputTheme=info.defaultValue
                              }

                            }else if(info.key ==='themeDescribe')
                            {
                              if(info.defaultValue!==null)
                              {
                                this.ueditor=info.defaultValue
                              }

                            }
                        }
                    }
                }
            },
            getTemplate(value){
              numTest=0

                this.inputTheme=''
                this.ueditor=''
                this.addWorkOrderDateList=[]
                this.addWorkOrderTimeList=[]
                this.addWorkOrderSingeList=[]
                this.addWorkOrderTextareaList=[]
                this.addWorkOrderSelectList=[]
                this.addWorkOrderRadioList=[]
                this.addWorkOrderCheckBoxList=[]
                this.addWorkOrderCascadeList=[]
                this.cascadeList=[]
                this.addOrderFieldCascadeList1=[]
                this.addOrderFieldCascadeList2=[]
                this.secondeOption=0
                this.thirdeOption=0
                this.cascadeOption1=[]
                this.cascadeOption3=[]
                this.cascadeOption2=[]
                this.selectCascaseDateTime=[]
                this.selectValue=[]
                this.defaultFieldRadio=[]
                this.checkList=[]
                this.singeInput=[]
                this.textarea=[]
                this.cascade2Option1=[]
                this.addWorkOrderTemplateList=[]
                console.log(value)
                if(value!==undefined)
                {

                    this.$http.get('/api/template/'+value).then(res=>{
                        this.selectTemplate=res.data.data

                        if(this.selectTemplate!==null){
                            this.setDefaultFieldChecked();
                          /*  this.addWorkOrderTemplateList=this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0]*/
                          this.$http.get('/api/field/list').then(res => {
                            this.filed.list = res.data.data
                            let add=this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0].filter(item=>this.filed.list.some(ele=>ele.id === item.fieldId))
                            this.addWorkOrderTemplateList=add
                        /*    this.selectTemplate.workOrderFieldList.fieldTwoDimensionalList[0].forEach(item=>{
                              if(item.field.type==='DATE_PICKER')
                              {
                                this.addWorkOrderDateList.push(item)
                              }

                              if(item.field.type==='TIME_PICKER')
                              {
                                this.addWorkOrderTimeList.push(item)


                              }
                              if(item.field.type==='INPUT')
                                this.addWorkOrderSingeList.push(item)
                              if(item.field.type==='TEXTAREA')
                                this.addWorkOrderTextareaList.push(item)

                              if(item.field.type==='SELECT')
                              {
                                this.addWorkOrderSelectList.push(item)


                              }

                              if(item.field.type==='CASCADER')
                              {
                                this.addOrderFieldCascadeList2.push(item)

                              }

                              if(item.field.type==='RADIO')
                                this.addWorkOrderRadioList.push(item)
                              if(item.field.type==='CHECKBOX')
                                this.addWorkOrderCheckBoxList.push(item)

                            })*/
                            for( let i=0;i<this.addWorkOrderTemplateList.length;i++)
                              this.defaultFieldRadio.push([])
                            for( let i=0;i<this.addWorkOrderTemplateList.length;i++)
                              this.checkList.push([])
                            for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                            {
                              if(this.addWorkOrderTemplateList[i].field.type==='SELECT')
                              {
                                this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                                  if(item._default==='true')
                                    this.selectValue[i]=item.value
                                })
                              }

                            }
                            for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                            {
                              if(this.addWorkOrderTemplateList[i].field.type==='RADIO')
                              {
                                this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                                  if(item._default==='true')
                                    this.defaultFieldRadio[i]=item.value
                                })
                              }
                            }
                            for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                            {
                              if(this.addWorkOrderTemplateList[i].field.type==='CHECKBOX')
                              {
                                this.addWorkOrderTemplateList[i].field.extInfo.exinfo.forEach(item=>{
                                  if(item._default==='true')
                                    this.checkList[[i]].push(item.value)

                                })
                              }
                            }
                            for (let i=0;i<this.addWorkOrderTemplateList.length;i++)
                            {

                              if(this.addWorkOrderTemplateList[i].field.type ==='INPUT')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null)
                                {

                                  this.singeInput[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }

                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='TEXTAREA')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.textarea[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }

                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='RADIO')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.defaultFieldRadio[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }
                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='SELECT')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.selectValue[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }
                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='CHECKBOX')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.checkList[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }

                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='TIME_PICKER')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.timePicker[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }

                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='DATE_PICKER')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.datePicker[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }

                              }
                              if(this.addWorkOrderTemplateList[i].field.type ==='CASCADER')
                              {
                                if(this.addWorkOrderTemplateList[i].defaultValue!==null){
                                  this.cascade2Option1[i]=this.addWorkOrderTemplateList[i].defaultValue
                                }
                              }


                            }
                          })

                        }
                    })
                }
                console.log( this.selectTemplate)
            },
            backworkOrder(){
                this.$router.back()
            },
            cacelClick(){
                this.$router.back()
            },
            onEditorBlur(){},
            onEditorFocus(){},
            onEditorChange(){},
            handleRemove(file, fileList) {
                console.log(file, fileList);
                this.fileList=fileList
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            handleChange(file,fileList){
                this.fileList = fileList.slice(-3);
                console.log(fileList)
            },

            //第二级下拉
            cascadeSelectOne(index,value)
            {
                this.addOrderFieldCascadeList1.forEach(item=>{
                    item.field.extInfo.cascadeDown[0].options.forEach(items=>{
                        if(items.value===value)
                        {

                            this.optionSelect2List[index]=items.children

                        }

                    })
                })
                if(this.cascadeOption1.length)
                {
                    let test=0
                    for (let i = 0; i <this.cascadeOption1.length;i++)
                    {
                        if(this.cascadeOption1[i]===value)
                        {
                            test=i

                        }

                    }
                    this.cascadeOption2[test]=''
                    this.cascadeOption3[test]=''
                 /*   this.cascadeList[test].push(value)*/

                }

            },
            //第三级下拉
            cascadeSelectTwo(index,value){
                this.optionSelect2List[index].forEach(item=>{
                    if(item.value===value)
                    {
                        this.optionSelect3List[index]=item.children

                    }


                })
                if(this.cascadeOption2.length)
                {
                    let test=0
                    for (let i = 0; i <this.cascadeOption2.length;i++)
                    {
                        if(this.cascadeOption2[i]===value)
                        {
                            test=i

                        }

                    }
                    this.cascadeOption3[test]=''
                  /*  this.cascadeList[test].push(value)*/
                }


            },
            cascadeHandleChange(id,value){
               this.fff[id]=value
                console.log(this.fff)
                console.log(this.cascadeList)

            },
            changeSelect(id,value){

                this.aaa[id]=value

            },
            test(a,b){
                for(let index in b)
                {
                    a[index]=b[index]
                }
                return a
            },
            cascadeSelectThire(value){
                console.log(value)
                let d
                for (let i = 0 ;i <this.cascadeOption1.length;i++)
                {
                    d=[]
                    d[0]=this.cascadeOption1[i]
                    if(this.cascadeOption2[i]!=='')
                    {
                        d[1]=this.cascadeOption2[i]
                    }
                   if(this.cascadeOption3[i]!=='')
                   {
                       d[2]=this.cascadeOption3[i]
                   }
                    this.cascadeList[i]=d
                }
             /*   console.log(this.cascadeOption2)
                console.log(this.cascadeOption1)
                console.log(this.cascadeOption3)

                console.log(this.cascadeList)
                console.log(this.addOrderFieldCascadeList1)*/
            },
            success(file){
                console.log(file)
            },

            modeUpload(item) {
                // console.log(item.file);
                this.mode=item.file
                console.log(item.file)
            },
            getDefaultField(){
                this.$http.get('/api/field/list').then(res=>{
                    this.fieldList=res.data.data
                })
            },
            loadMoreClient(){
                this.pageSize+=100
                this.getClientList()

            },
            loadMoreCompany(){
                this.companyPageSize+=100
                console.log('aaa')
                this.getClientCompany()
            },
            addClientCompany(){
                if(this.companyLevelRadio==='1')
                    this.grade='NORMAL'
                if(this.companyLevelRadio==='2')
                    this.grade='VIP'
                if(this.addCompanyName==='')
                    this.$message.error('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {

                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.addCompanyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompany()


                    });
                    this.dialogFormVisible1=false

                }

            },

            addCompanyContinue(){
                if(this.companyLevelRadio==='1')
                    this.grade='NORMAL'
                if(this.companyLevelRadio==='2')
                    this.grade='VIP'
                if(this.addCompanyName==='')
                    this.$message.error('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {

                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.addCompanyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompany()
                    });
                    this.contactPerson=''
                    this.contactPersonMail=''
                    this.contactPersonTel=''
                    this.description=''
                    this.companyGroupValue=''
                    this.companyName=''
                    this.emailSuffix=''
                    this.levelRadio='1'
                    this.companyPersonValue=''
                    this.dialogFormVisible1=true
                }

                /*   console.debug('post field response:', res);*/


            },
            phoneBlurClick(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.contactPersonTel!=='')
                {
                    if(!phone.test(this.contactPersonTel))
                        this.$message('请输入有效的电话号码')
                }

            },
            emaiBblurClick(){
                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.contactPersonMail!=='')
                {
                    if(!reg.test(this.contactPersonMail))
                        this.$message('请输入有效的邮箱')
                }

            },
            getCompanyAccountPerson(){
                if(this.companyGroupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.companyGroupValue).then(res=>{
                        this.companyAccountPerson.list=res.data.data
                        this.companySelectPerson=res.data.data
                    })
                }
                if(this.companyGroupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.companyAccountPerson.list=res.data.data
                        this.companySelectPerson=res.data.data
                    })
                }


            },
            changeInput(value){
                if(value!=='')
                {
                    let selectClient=[]
                     this.client.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectClient.push(item)
                        }
                    })
                    this.selectClient=selectClient

                    console.log(selectClient)
                }
                else
                {
                    this.selectClient=this.client.list
                }
            },
            changeInputGroup(value){
                if(value!=='')
                {
                    let selectGroup=[]
                    this.accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectGroup.push(item)
                        }
                    })
                    this.selectGroup=selectGroup

                    console.log(this.companySelectGroup)
                }
                else
                {
                    this.selectGroup=this.accountGroup.list
                }
            },
            changeInputPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectAccountPerson=selectPerson

                }
                else
                {
                    this.selectAccountPerson=this.accountPerson.list
                }
            },
            changeFocusPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPersons.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectFocusPerson=selectPerson

                }
                else
                {
                    this.selectFocusPerson=this.accountPersons.list
                }
            },

            //新增客户中的搜索公司
            changeSelectCompany(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. company.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyList=selectCompany

                }
                else
                {
                    this.selectCompanyList=this.company.list
                }

            },
            //公司中的负责组搜索
            getSelectCompanyGroup(value){
                if(value!=='')
                {
                    let selectGroup=[]
                    this.accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectGroup.push(item)
                        }
                    })
                    this.companySelectGroup=selectGroup

                    console.log(this.companySelectGroup)
                }
                else
                {
                    this.companySelectGroup=this.accountGroup.list
                }
            },
            getSelectCompanyPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.companyAccountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.companySelectPerson=selectPerson

                }
                else
                {
                    this.companySelectPerson=this.companyAccountPerson.list
                }
            },



            },
    }
</script>

<style  lang="less">
@import "../../../assets/less/workorder/addworkorder/addworkorder";
    .newClassStyle1{
        flex: none;
        width: 41.666%;
        .defaultFiledSelect{
            padding-right: 10px;
            width: 56%;
        }
        .addOrderDefaultFiledCascade2{
            padding-right: 10px;
            width: 56%;

        }
        .defaultFieldDatePicker{
            padding-right: 10px;
            width: 56%;
        }
        .defaultFieldTimePicker{
            padding-right: 10px;
            width: 56%;

        }

    }
.newClassStyle2{
    flex: none;
    width: 29.166%;
    .defaultFiledSelect{
        padding-right: 65px;
    }
    .addOrderDefaultFiledCascade2{
        padding-right: 65px;
        padding-left: 10px;
         }
    .defaultFieldDatePicker{
        padding-right: 65px;
        padding-left: 10px;
    }
    .defaultFieldTimePicker{
        padding-left: 10px;
        padding-right: 65px;
    }
}
.newClassStyle3{
    flex: none;
    width: 29.166%;
    .defaultFiledSelect{
        padding-left: 70px;
    }
    .addOrderDefaultFiledCascade2{
        padding-left: 70px;
    }
    .defaultFieldDatePicker{
        padding-left: 70px;
    }
    .defaultFieldTimePicker{
        padding-left: 70px;
    }
}
    .otherClassStyle{
        flex: none;
        width: 100%;
    }
</style>